module.exports = __webpack_public_path__ + "static/media/Ketly-Logo_Final-Output_Reverse.50345661.jpg";